import ProfileIcon from "@/images/navbar_logged_out_profile_icon.svg?react";
import RegistrationIcon from "@/images/registration_icon.svg?react";
import UserIcon from "@/images/user_profile_icon.svg?react";
import {type FC} from "react";
import {useTranslation} from "react-i18next";
import {Link} from "react-router";

const NavbarLoggedOutProfile: FC = () => {
  const {t} = useTranslation("navigation");

  return (
    <div className="group relative flex items-center justify-center">
      <div className="flex items-center py-3 pr-1 pl-2 group-hover:pr-[1px] group-hover:pl-[5px]">
        <div className="group-hover:border-netutral-grey-dark rounded-full group-hover:border-[3px]">
          <div className="border-neutral-grey-light group-hover:border-primary-dark-solid flex h-10 w-10 items-center justify-center rounded-full border group-hover:border-2">
            <ProfileIcon className="size-[22px] shrink-0" />
          </div>
        </div>
      </div>
      <ul className="text-primary-black divide-neutral-white-dark border-neutral-white-dark absolute right-0 bottom-0 h-auto w-32 origin-top-right translate-y-[72px] scale-0 divide-y rounded-md border bg-white pl-0 text-xs shadow-lg transition-all group-hover:scale-100">
        <li key="login">
          <Link
            className="hover:bg-neutral-white-dark flex items-center gap-2 px-3 py-2"
            style={{
              textDecoration: "none",
            }}
            to={"/login/"}>
            <UserIcon className="size-4 shrink-0" />
            <span>{t("login")}</span>
          </Link>
        </li>
        <li key="register">
          <Link
            className="hover:bg-neutral-white-dark flex items-center gap-2 px-3 py-2"
            style={{
              textDecoration: "none",
            }}
            to={"/register/"}>
            <RegistrationIcon className="size-4 shrink-0" />
            <span>{t("register")}</span>
          </Link>
        </li>
      </ul>
    </div>
  );
};
export default NavbarLoggedOutProfile;
